// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1-E0w","title":"InfoRow_title__1V42S"};